/* DO NOT FORGET to add export of this file to /src/store/reducers/index.js */
import * as FP from '../../utils/fp-js';

export const sentMessages = (state, action) =>
  FP.match(action.type).on('SET_sentMessages', action.payload).otherwise(state);
